export default __webpack_public_path__ + "static/raghu-839b0d4011e9089c552578ac6f15eacf.jpg";